import {
  LayoutCard,
  LayoutCardContainer,
  LayoutCards,
  LayoutLabel,
  LoadingAnimation,
  GeneratingContentStyled,
} from "./styles";
import { getZonesPreview } from "./getZonesPreivew";
import {
  ChannelLayout,
  OnboardingCommonAppInstanceTemplatesQuery,
} from "src/types.g";
import { getIndustry, getPlaceholderTemplateByIndustry } from "../utils";
import { useAppContext } from "src/hooks/useAppContext";
import { CoverOverlay } from "./CoverOverlay";
import { UUID } from "@screencloud/uuid";
import { PresetColors } from "../Styling";
import { FormattedMessage } from "react-intl";

export const LayoutSelection = ({
  commonAppInstanceTemplates,
  selectedLayout,
  selectedTemplateIds,
  handleLayoutClick,
  logoThumbnail,
  presetColors,
  isGenerating,
}: {
  commonAppInstanceTemplates: OnboardingCommonAppInstanceTemplatesQuery["allCommonAppInstanceTemplates"];
  selectedLayout: ChannelLayout | null;
  selectedTemplateIds: UUID[];
  handleLayoutClick: (layout: ChannelLayout) => void;
  logoThumbnail: string | null;
  presetColors: PresetColors;
  isGenerating: boolean;
}) => {
  const context = useAppContext();
  const templatePlaceholder = getPlaceholderTemplateByIndustry({
    templateName:
      commonAppInstanceTemplates?.nodes.find((template) =>
        (selectedTemplateIds ?? []).includes(template.id),
      )?.name || "",
    industry: getIndustry(context.currentOrg),
  });

  const zonesPreivew = getZonesPreview({
    templatePlaceholder,
    logoThumbnail,
    presetColors,
  });

  if (isGenerating) {
    return (
      <GeneratingContentStyled>
        <LoadingAnimation>
          <svg
            className="left"
            width="116"
            height="146"
            viewBox="0 0 116 146"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M-5.14948e-08 4.7929C-2.3055e-08 2.14585 2.14585 8.89588e-08 4.7929 1.98695e-07L84.355 3.49703e-06L115.03 30.6746L115.03 140.911C115.03 143.558 112.884 145.704 110.237 145.704L4.7929 145.704C2.14586 145.704 -1.54239e-06 143.558 -1.51395e-06 140.911L-5.14948e-08 4.7929Z"
              fill="white"
            />
            <ellipse
              cx="34.7855"
              cy="49.0961"
              rx="15.3373"
              ry="15.3373"
              fill="#FCC05E"
            />
            <path
              d="M84.355 30.6746L115.03 30.6746L84.355 3.05176e-05L84.355 30.6746Z"
              fill="#EEEEEE"
            />
            <path
              d="M60.2027 94.8569L88.3115 64.0331L115.03 89.5637L115.03 140.911C115.03 143.558 112.884 145.704 110.237 145.704L4.7929 145.704C2.14586 145.704 7.37711e-07 143.558 7.13155e-07 140.911L5.09624e-07 118.971L45.4662 80.1267L60.2027 94.8569Z"
              fill="#9292F7"
            />
          </svg>
          <svg
            className="center"
            width="116"
            height="146"
            viewBox="0 0 116 146"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M0.952637 4.7929C0.952637 2.14585 3.09849 0 5.74554 0H85.3077L115.982 30.6746V140.911C115.982 143.558 113.836 145.704 111.189 145.704H5.74554C3.09849 145.704 0.952637 143.558 0.952637 140.911V4.7929Z"
              fill="white"
            />
            <ellipse
              cx="58.4675"
              cy="72.8521"
              rx="30.6746"
              ry="30.6746"
              fill="#E6725C"
            />
            <path
              d="M51.1896 81.7727C51.2045 82.6746 51.6691 83.5093 52.4279 83.9971C53.1866 84.4849 54.139 84.5611 54.9656 84.2001L68.9908 75.839C69.7726 75.3903 70.2786 74.5807 70.3393 73.6813C70.4157 72.7431 69.8675 71.866 68.9908 71.5236L54.9656 63.1624C54.1484 62.6763 53.1266 62.694 52.3268 63.2082C51.527 63.7224 51.0866 64.6446 51.1896 65.5899V81.7727Z"
              fill="#F8FAFF"
            />
            <path
              d="M85.3076 30.6746H115.982L85.3076 0V30.6746Z"
              fill="#EEEEEE"
            />
          </svg>
          <svg
            className="right"
            width="116"
            height="146"
            viewBox="0 0 116 146"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M0.952637 4.7929C0.952637 2.14585 3.09849 -8.13925e-08 5.74554 -1.81795e-07L85.3077 -3.1996e-06L115.982 30.6746L115.982 140.911C115.982 143.558 113.836 145.704 111.189 145.704L5.74553 145.704C3.09849 145.704 0.952631 143.558 0.952631 140.911L0.952637 4.7929Z"
              fill="white"
            />
            <path
              d="M16.29 54.0639C16.29 52.158 17.8351 50.613 19.7409 50.613L55.0167 50.613C56.9225 50.613 58.4675 52.1581 58.4675 54.0639C58.4675 55.9698 56.9225 57.5148 55.0167 57.5148L19.7409 57.5148C17.8351 57.5148 16.29 55.9698 16.29 54.0639Z"
              fill="#E8EAF2"
            />
            <path
              d="M85.3076 30.6746L115.982 30.6746L85.3076 0L85.3076 30.6746Z"
              fill="#EEEEEE"
            />
            <path
              d="M16.29 92.0237C16.29 90.1178 17.8351 88.5728 19.7409 88.5728L97.1942 88.5728C99.1001 88.5728 100.645 90.1178 100.645 92.0237C100.645 93.9296 99.1001 95.4746 97.1942 95.4746L19.7409 95.4746C17.8351 95.4746 16.29 93.9295 16.29 92.0237Z"
              fill="#E8EAF2"
            />
            <path
              d="M16.29 66.7172C16.29 64.8113 17.8351 63.2663 19.7409 63.2663L97.1942 63.2663C99.1001 63.2663 100.645 64.8113 100.645 66.7172C100.645 68.6231 99.1001 70.1681 97.1942 70.1681L19.7409 70.168C17.8351 70.168 16.29 68.623 16.29 66.7172Z"
              fill="#E8EAF2"
            />
            <path
              d="M16.29 79.3704C16.29 77.4645 17.8351 75.9195 19.7409 75.9195L97.1942 75.9195C99.1001 75.9195 100.645 77.4645 100.645 79.3704C100.645 81.2763 99.1001 82.8213 97.1942 82.8213L19.7409 82.8213C17.8351 82.8213 16.29 81.2763 16.29 79.3704Z"
              fill="#E8EAF2"
            />
          </svg>
        </LoadingAnimation>
        <h2>
          <FormattedMessage
            id="design_my_screen_modal.generating_content"
            defaultMessage="Generating your screen content..."
          />
        </h2>
      </GeneratingContentStyled>
    );
  }

  return (
    <LayoutCards>
      {zonesPreivew.map((zone, index) => {
        const isSelected = selectedLayout === zone.key;
        return (
          <LayoutCardContainer
            isSelected={isSelected}
            onClick={() => handleLayoutClick(zone.key)}
          >
            <LayoutCard
              selected={isSelected}
              className="layout-card"
              key={index}
            >
              {zone.preview}
              {!isSelected && (
                <CoverOverlay
                  layout={zone.key}
                  coverColor={presetColors.primary}
                />
              )}
            </LayoutCard>
            <LayoutLabel className="layout-label">{zone.label}</LayoutLabel>
          </LayoutCardContainer>
        );
      })}
    </LayoutCards>
  );
};
